import styled from 'styled-components';

export const PageContentStyles = styled.section`
  width: var(--page-width);
  padding: 80px 32px;
  margin: 0 auto;
`;
